import React, { FC } from 'react'

import { ArrowToLineIcon } from './ArrowToLine.icon'
import { BoldPlusIcon } from './BoldPlus.icon'
import { CheckIcon } from './Check.icon'
import { DownArrowIcon } from './DownArrow.icon'
import { EmailIcon } from './Email.icon'
import { FacebookIcon } from './Facebook.icon'
import { InstagramIcon } from './Instagram.icon'
import { LinkIcon } from './Link.icon'
import { LinkedInIcon } from './LinkedIn.icon'
import { PinterestIcon } from './Pinterest.icon'
import { PlayIcon } from './Play.icon'
import { TimeIcon } from './Time.icon'
import { UpRightArrowIcon } from './UpRightArrow.icon'
import { UsersIcon } from './Users.icon'
import { VerifiedIcon } from './Verified.icon'
import { XIcon } from './X.icon'
import { YouTubeIcon } from './YouTube.icon'

type IconProps = {
  name: string
  className?: string
  size?: number
  direction?: 'up' | 'down' | 'left' | 'right'
}

const IconProvider: FC<IconProps> = ({ name, className, size = 24, direction = 'up' }) => {
  switch (name) {
    case 'arrowToLine':
      return <ArrowToLineIcon className={className} size={size} />
    case 'upRightArrow':
      return <UpRightArrowIcon className={className} size={size} />
    case 'arrow':
      return <DownArrowIcon className={className} direction={direction} size={size} />
    case 'boldPlus':
      return <BoldPlusIcon className={className} size={size} />
    case 'link':
      return <LinkIcon className={className} size={size} />
    case 'email':
      return <EmailIcon className={className} size={size} />
    case 'facebook':
      return <FacebookIcon className={className} size={size} />
    case 'instagram':
      return <InstagramIcon className={className} size={size} />
    case 'linkedIn':
      return <LinkedInIcon className={className} size={size} />
    case 'linkedin':
      return <LinkedInIcon className={className} size={size} />
    case 'pinterest':
      return <PinterestIcon className={className} size={size} />
    case 'x':
      return <XIcon className={className} size={size} />
    case 'youtube':
      return <YouTubeIcon className={className} size={size} />
    case 'time':
      return <TimeIcon className={className} size={size} />
    case 'users':
      return <UsersIcon className={className} size={size} />
    case 'play':
      return <PlayIcon className={className} size={size} />
    case 'verified':
      return <VerifiedIcon className={className} size={size} />
    case 'check':
      return <CheckIcon className={className} />
    default:
      return null // Or a fallback icon
  }
}

export default IconProvider
